(function () {
  function getProductMediaData(gallery) {
    const scriptId = gallery.getAttribute("data-product-media-script-id");
    if (!scriptId) return null;
    const script = document.getElementById(scriptId);
    if (!script || script.getAttribute("data-product-media") === null)
      return null;
    try {
      return JSON.parse(script.textContent);
    } catch {
      return null;
    }
  }

  function getVisibleIndexes(productMedia, colorOption, onlyShowVariantMedia) {
    if (!Array.isArray(productMedia)) return [];
    const color = (colorOption || "").toLowerCase();
    return productMedia
      .map((media, index) => {
        const alt = (media.alt || "").toLowerCase();
        const hasBrackets = alt.includes("[") && alt.includes("]");
        const show =
          !hasBrackets ||
          !onlyShowVariantMedia ||
          (color.length > 0 && alt.includes(color));
        return show ? index : -1;
      })
      .filter((i) => i >= 0);
  }

  function indexesToHide(productMediaLength, visibleIndexes) {
    const set = new Set(visibleIndexes);
    const hide = [];
    for (let i = 0; i < productMediaLength; i++) {
      if (!set.has(i)) hide.push(i);
    }
    return hide;
  }

  function applyGalleryFilter(gallery, indexesToHideList) {
    const carousel = gallery.querySelector(".product-gallery__carousel");
    if (carousel && typeof carousel.filter === "function") {
      carousel.filter(indexesToHideList);
    }

    const thumbnails = gallery.querySelectorAll(".product-gallery__thumbnail");
    thumbnails.forEach((el, i) => {
      el.toggleAttribute("hidden", indexesToHideList.includes(i));
    });

    const dotsNav = gallery.querySelector("carousel-navigation[aria-controls]");
    if (dotsNav) {
      const dots = dotsNav.querySelectorAll("button.tap-area");
      dots.forEach((el, i) => {
        el.toggleAttribute("hidden", indexesToHideList.includes(i));
      });
    }
  }

  function handleVariantChange(event) {
    const variant = event.detail?.variant;
    const gallery = document.querySelector(
      "product-gallery[data-product-media-script-id]"
    );
    if (!variant || !gallery) return;

    if (document.querySelector("quick-buy-modal[open]")) return;

    const productMedia = getProductMediaData(gallery);
    if (!productMedia || productMedia.length === 0) return;

    const onlyShowVariantMedia =
      gallery.getAttribute("data-only-show-variant-media") === "true";
    const colorOption =
      variant.options && variant.options[0]
        ? String(variant.options[0]).toLowerCase()
        : "";

    const visibleIndexes = getVisibleIndexes(
      productMedia,
      colorOption,
      onlyShowVariantMedia
    );
    const hideList = indexesToHide(productMedia.length, visibleIndexes);

    applyGalleryFilter(gallery, hideList);
  }

  document.addEventListener("variant:change", handleVariantChange, {
    passive: true,
  });
})();
